module.exports = __webpack_public_path__ + "img/40_38_024_090.9026bdc9.jpg";